import {z} from "zod";

export const TtsModeSchema = z.enum(["client", "aura"]);
export type TtsMode = z.infer<typeof TtsModeSchema>;
